const objSearchBtn = $('.btn-search').data('name'); // Get button name
const objExportBtn = $('.btn-export').data('name'); // Get button name

// My Customize DataTable //
$.MyDataTable = function(tableID, url, columns, aaSorting = 0, orderType = 'ASC') {
    if ($('#' + tableID).length) {
        const dtTable = $('#' + tableID).dataTable({
            processing: true,
            serverSide: true,
            stateSave: true,
            responsive: true,
            autoWidth: false,
            scrollX: true,
			pageLength: 10,
            ajax: url,
            aaSorting: [
                [aaSorting, orderType]
            ],
            dom: "<'row text-sm mt-2 mb-0'<'export_wrapper col-md-6 mb-0'B><'filter_wrapper col-md-6 mb-0'f>>" +
                // "<'row'<'col-md-6'><'col-md-6'>>" +
                "<'row text-sm mt-2 mb-0'<'col-md-12't>><'row text-sm mt-2 mb-0'<'col-md-4'l><'col-md-4 text-center'i><'col-md-4'p>>",
            columnDefs: [{
                targets: 'no-sort',
                orderable: false
            }],
            lengthMenu: [
                [5, 10, 20, 50, 100, -1],
                [5, 10, 20, 50, 100, "All"]
            ],
            language: {
                // sProcessing: '<img src="./images/loading-gear.gif">',
                // 'oPaginate': { sFirst: '&laquo;', sLast: '&raquo;', sNext: '&#8250;', sPrevious: '&#8249;' }
                'oPaginate': { sFirst: '<<', sLast: '>>', sNext: '>', sPrevious: '<' }
            },
            "initComplete": function(settings, json) {
                getFilterStatus();
                getExportStatus();
            },
            buttons: [{
                    extend: 'copy',
                    text: '<i class="bi bi-clipboard-check"></i>',
                    titleAttr: 'Copy',
                    className: 'btn-sm btn-neutral border-base',
                    exportOptions: {
                        columns: "thead th:not(.noExport)"
                    }
                },
                {
                    extend: 'csv',
                    text: '<i class="bi bi-filetype-csv"></i>',
                    titleAttr: 'CSV',
                    className: 'btn-sm btn-neutral border-base',
                    exportOptions: {
                        columns: "thead th:not(.noExport)"
                    }
                },
                {
                    extend: 'excel',
                    text: '<i class="bi bi-filetype-xlsx"></i>',
                    titleAttr: 'Excel',
                    className: 'btn-sm btn-neutral border-base',
                    exportOptions: {
                        columns: "thead th:not(.noExport)"
                    }
                },
                {
                    extend: 'pdfHtml5',
                    text: '<i class="bi bi-filetype-pdf"></i>',
                    titleAttr: 'PDF',
                    className: 'btn-sm btn-neutral border-base',
                    orientation: 'portrait',
                    pageSize: 'LEGAL',
                    exportOptions: {
                        columns: "thead th:not(.noExport)"
                    }
                },
                {
                    extend: 'print',
                    text: '<i class="bi bi-printer"></i>',
                    titleAttr: 'Print',
                    className: 'btn-sm btn-neutral border-base',
                    exportOptions: {
                        columns: "thead th:not(.noExport)"
                    }
                },
                {
                    extend: 'colvis',
                    text: '',
                    titleAttr: 'Select column',
                    className: 'btn-sm btn-neutral border-base',
                    exportOptions: {
                        columns: "thead th:not(.noExport)"
                    }
                },
            ],
            columns: columns
        });
        return dtTable;
    }

    // Call event on checkbox
    //initCheckbox(tableID);

};
//My Customize DataTable //

// Filter Button Toggle
function getFilterStatus() {
    if (localStorage.getItem("datatable.search." + objSearchBtn) === null) {
        $('.btn-search').removeClass('text-danger');
        $('.filter_wrapper').show();
    } else {
        if ((localStorage.getItem("datatable.search." + objSearchBtn) === 'true')) {
            $('.btn-search').removeClass('text-danger');
            $('.filter_wrapper').show();

        } else {
            $('.filter_wrapper').hide();
            $('.btn-search').addClass('text-danger');
        }
    }
}

$('.btn-search').on('click', function(event) {
    $('.filter_wrapper').toggle(function() {
        if (localStorage.getItem("datatable.search." + objSearchBtn) === 'false') {
            localStorage.setItem("datatable.search." + objSearchBtn, 'true');
        } else {
            localStorage.setItem("datatable.search." + objSearchBtn, 'false');
        }
        getFilterStatus();
    });
});


// Export Button Toggle
function getExportStatus() {
    if (localStorage.getItem("datatable.export." + objExportBtn) === null) {
        $('.btn-export').removeClass('text-danger');
        $('.export_wrapper').show();
    } else {
        if ((localStorage.getItem("datatable.export." + objExportBtn) === 'true')) {
            $('.btn-export').removeClass('text-danger');
            $('.filter_wrapper').removeClass('col-md-12');
            $('.export_wrapper').show();

        } else {
            $('.export_wrapper').hide();
            $('.filter_wrapper').addClass('col-md-12');
            $('.btn-export').addClass('text-danger');

        }
    }
}

$('.btn-export').on('click', function(event) {
    $('.export_wrapper').toggle(function() {
        if (localStorage.getItem("datatable.export." + objExportBtn) === 'false') {
            localStorage.setItem("datatable.export." + objExportBtn, 'true');
        } else {
            localStorage.setItem("datatable.export." + objExportBtn, 'false');
        }
        getExportStatus();
    });
});